export default __webpack_public_path__ + "208c85096706a579fa8e3f864e12cb54.svg";